import { useEffect } from 'react';

interface UseFailSafeOnCorrectParams {
  isCorrectSelected: boolean;
  getDurationAndPosition: () => { duration: number; position: number };
  onTrigger: () => void;
  onBeforeTrigger?: () => void;
  hasFiredRef: React.MutableRefObject<boolean>;
}

export const useFailSafe = ({
  isCorrectSelected,
  getDurationAndPosition,
  onTrigger,
  onBeforeTrigger,
  hasFiredRef,
}: UseFailSafeOnCorrectParams) => {
  // This is to ensure after answer is correctly verified, the user is automatically navigated to the next exercise (related to SDB-358)

  useEffect(() => {
    if (!isCorrectSelected || hasFiredRef.current) {
      return;
    }

    const { duration, position } = getDurationAndPosition();
    const timeLeft = Math.max(duration - position, 0);
    const fallbackDelay = duration > 0 ? (timeLeft + 1) * 1000 : 3000;

    const fallback = setTimeout(async () => {
      if (!hasFiredRef.current && isCorrectSelected) {
        onBeforeTrigger?.();
        onTrigger();
        hasFiredRef.current = true;
      }
    }, fallbackDelay);

    return () => clearTimeout(fallback);
  }, [isCorrectSelected, getDurationAndPosition]);
};
